// extracted by mini-css-extract-plugin
export default {"title":"CardLayout_title__AYi7K","title-icon":"CardLayout_title-icon__-haRS"};